// Janela "float" do Tauri: só desenha a barra. Recebe o estado da janela principal
// e devolve os comandos (pausar, finalizar, abrir...). Guarda a posição ao arrastar.
import { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { Language } from './domain/settings';
import { initI18n } from './i18n';
import type { DesktopBridge, FloatSnapshot } from './platform/desktop';
import { applyTheme } from './state/useTheme';
import { FloatBar } from './ui/FloatBar';

const EMPTY: FloatSnapshot = {
  task: null,
  offline: false,
  pomodoro: null,
  celebrating: null,
  clockOffset: 0,
  language: 'pt-BR',
  theme: 'dark',
};

export function FloatApp({ bridge }: { bridge: DesktopBridge }) {
  const [snapshot, setSnapshot] = useState<FloatSnapshot>(EMPTY);
  const [now, setNow] = useState(() => Date.now());
  const i18n = initI18n((snapshot.language as Language) ?? 'pt-BR');

  useEffect(() => {
    document.documentElement.classList.add('is-float');
    const offs: Array<Promise<() => void>> = [bridge.onSnapshot(setSnapshot), bridge.trackFloatPosition()];
    void bridge.sendCommand({ type: 'ready' });
    return () => offs.forEach((p) => void p.then((off) => off()));
  }, [bridge]);

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => applyTheme(snapshot.theme), [snapshot.theme]);

  return (
    <I18nextProvider i18n={i18n}>
      <FloatBar snapshot={snapshot} now={now + snapshot.clockOffset} onCommand={(cmd) => void bridge.sendCommand(cmd)} />
    </I18nextProvider>
  );
}
